import request from '~/utils/request';
import { DESIGNER_QUERY_STATUS } from '~/utils/constants';

export { DESIGNER_QUERY_STATUS };

export const getOneDesignerTemplateQuery = async (id) => {
  try {
    return request.get(`admin/custom-template-queries/${id}/template-details`);
  } catch (error) {
    return error.response;
  }
};

export const getDesignerTemplateQueryDetails = async (id) => {
  try {
    return request.get(`admin/custom-template-queries/${id}`);
  } catch (error) {
    return error.response;
  }
};

export const updateTemplateQuery = async (id, formData) => {
  try {
    return request.post(`admin/custom-template-queries/${id}/update-template`, formData);
  } catch (error) {
    return error.response;
  }
};

const getFirstValue = (sources, keys) => {
  for (const source of sources) {
    if (!source || typeof source !== 'object') {
      continue;
    }

    for (const key of keys) {
      const value = source[key];

      if (value !== null && value !== undefined && value !== '') {
        return value;
      }
    }
  }

  return undefined;
};

export const submitTemplateQueryForApproval = async (data) => {
  const meta = data?.meta || {};
  const template = data?.template || {};
  const sources = [meta, template, data];

  const payload = {
    status: DESIGNER_QUERY_STATUS.SUBMITTED_FOR_APPROVAL,
  };

  const templatePath = getFirstValue(sources, ['templatePath', 'template_path']);
  const thumbnailPath = getFirstValue(sources, ['thumbnailPath', 'thumbnail_path']);
  const backTemplatePath = getFirstValue(sources, ['backTemplatePath', 'back_template_path']);
  const backThumbnailPath = getFirstValue(sources, ['backThumbnailPath', 'back_thumbnail_path']);
  const comment = getFirstValue([data], ['approvalComment', 'comment']);

  if (templatePath) payload.templatePath = templatePath;
  if (thumbnailPath) payload.thumbnailPath = thumbnailPath;
  if (backTemplatePath) payload.backTemplatePath = backTemplatePath;
  if (backThumbnailPath) payload.backThumbnailPath = backThumbnailPath;
  if (comment) payload.comment = comment;

  try {
    return request.post(`admin/custom-template-queries/${data.id}/update-query`, payload);
  } catch (error) {
    return error.response;
  }
};
